/*
 * GBAC Custom Pack Builder: gbac-pack-builder.js
 * Created 2026-09-03. Revised 2026-09-04 from Deven's Loom of 2026-09-03.
 *
 * Drives snippets/gbac-pack-builder.liquid. Reads the JSON product map the
 * snippet embeds (one entry per pack_handles product) and does ALL pricing
 * and row-swap logic here so there is exactly one source of truth for the
 * numbers on screen.
 *
 * THE SAME CART SHIM TRAP AS THE OLDER BUNDLE BUILDER, and it is our own
 * code, not an app. layout/theme.liquid wraps window.fetch to hand plain
 * /cart/add POSTs to Monster Cart's own API: a plain POST that carries
 * neither `m=true` (Monster's own) nor `gbac=1` is handed off and answered
 * with a synthetic 200 {"items":[]}. So a pack posts to '/cart/add.js?gbac=1'
 * (passes straight through; the shim then calls monster_refresh()). Do NOT
 * bypass this with an unpatched iframe fetch: that evades the dedupe and
 * Monster Cart adds a second copy of any line it recognizes (measured on the
 * older builder: 5 units landed for a 4-item add via that route).
 *
 * ADD-TO-CART HAND-OFF (Loom 2026-09-03: "let's go back to using our regular
 * add to cart, with more payment options, Shop Pay and so on, instead of the
 * custom gold button"). The theme's own buttons block renders on these pages
 * again. On init this script moves the widget's .gbac-pb__submit (error line
 * + a button carrying the theme's .btn classes) into that block's
 * .product__submit, then toggles `gbac-pack-mode` on it:
 *   Single Chain -> the theme's real form: quantity, Add to cart, Shop Pay,
 *                   More payment options. Untouched, so it behaves exactly
 *                   as on every other PDP.
 *   2-Pack/5-Pack -> the native buttons are hidden and the pack button
 *                   (same .btn classes, so it looks native) posts N lines.
 *                   Dynamic checkout buttons can only buy one variant, so
 *                   they cannot serve a pack; they are hidden with the form.
 * If the buttons block is missing, the submit stays inside the widget.
 *
 * FINISH/LENGTH ARE SEPARATE PRODUCTS, NOT VARIANTS. Every row picks between
 * up to 4 real Shopify products (24"/30" x Gold/Silver). "Changing a select"
 * means re-pointing the row at a different product's id/price, not changing
 * a variant option.
 */
(function () {
  'use strict';

  if (window.__gbacPackBuilderLoaded) return;
  window.__gbacPackBuilderLoaded = true;

  var ADD_URL = '/cart/add.js?gbac=1';
  var FINISHES = ['Gold', 'Silver'];
  var LENGTHS = ['24"', '30"'];

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    amount = parts.join('.');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  function init(root) {
    if (root.__gpbInit) return;
    root.__gpbInit = true;

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var rate2 = parseFloat(root.getAttribute('data-rate-2') || '10');
    var rate5 = parseFloat(root.getAttribute('data-rate-5') || '28');
    var currentHandle = root.dataset.currentHandle;

    var dataScript = root.querySelector('[data-gbac-pack-products]');
    var products = {};
    try { products = JSON.parse((dataScript && dataScript.textContent) || '{}'); } catch (e) { products = {}; }
    var handles = Object.keys(products);
    var current = products[currentHandle];
    if (!current || !handles.length) return;
    LENGTHS = ['24"', '30"'].filter(function (l) { return handles.some(function (h) { return products[h].length === l; }); });
    var multiLength = LENGTHS.length > 1;

    function findProduct(finish, length) {
      for (var i = 0; i < handles.length; i++) {
        var p = products[handles[i]];
        if (p.finish === finish && p.length === length) return p;
      }
      return null;
    }
    function otherFinish(f) { return f === 'Gold' ? 'Silver' : 'Gold'; }
    function rowFor(p) { return { finish: p.finish, length: p.length, handle: p.handle }; }

    /* Row defaults.
       2-Pack (Loom 2026-09-03, "this should start again, one silver, one
       gold"): row 1 is the page's own chain, row 2 is the other finish in the
       same length, so the default 2-Pack is the gold + silver pairing the Set
       already sells. If that other finish is sold out today (30" Gold at the
       time of writing) row 2 falls back to the page's chain, so the default
       pack is never blocked at the button.
       5-Pack (Deven, 2026-09-03 evening, unchanged): every row is the page's
       own chain, as TrueForm pre-fills every row with the shirt on the page. */
    function defaultRows(count) {
      var rows = [];
      for (var i = 0; i < count; i++) rows.push(rowFor(current));
      if (count === 2) {
        var mate = findProduct(otherFinish(current.finish), current.length);
        if (mate && mate.available) rows[1] = rowFor(mate);
      }
      return rows;
    }

    var rowsState = { '2': defaultRows(2), '5': defaultRows(5) };
    var tier = '2';

    var submitEl = root.querySelector('[data-gbac-submit]');
    var errEl = root.querySelector('[data-gbac-error]');
    var addBtn = root.querySelector('[data-gbac-add]');
    var addLabelEl = root.querySelector('[data-gbac-cta-label]');
    var addPriceEl = root.querySelector('[data-gbac-cta-price]');
    var addWasEl = root.querySelector('[data-gbac-cta-was]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-gbac-radio]'));
    var ctaLabel = root.dataset.ctaLabel || 'Add to cart';

    /* Hand-off target: the theme's buttons block in the same buy box. */
    var content = root.closest('.product__content') || document;
    var nativeSubmit = content.querySelector('.product__block--buttons .product__submit');
    if (nativeSubmit && submitEl) {
      nativeSubmit.appendChild(submitEl);
    }
    function setPackMode(on) {
      if (nativeSubmit) nativeSubmit.classList.toggle('gbac-pack-mode', on);
      if (submitEl) submitEl.hidden = !on;
    }

    function rowCompareCents(p) { return (p.compareCents > p.priceCents) ? p.compareCents : p.priceCents; }
    function rowPackCents(p, tierKey) {
      var rate = tierKey === '2' ? rate2 : rate5;
      return Math.round(p.priceCents * (1 - rate / 100));
    }

    function packTotals(tierKey) {
      if (tierKey === '1') {
        return {
          now: current.priceCents,
          was: rowCompareCents(current),
          allAvailable: !!current.available
        };
      }
      var rows = rowsState[tierKey];
      var now = 0, was = 0, allAvailable = true;
      rows.forEach(function (r) {
        var p = products[r.handle];
        now += rowPackCents(p, tierKey);
        was += rowCompareCents(p);
        if (!p.available) allAvailable = false;
      });
      return { now: now, was: was, allAvailable: allAvailable };
    }

    function pctSaved(totals) {
      if (totals.was <= 0 || totals.was <= totals.now) return 0;
      return Math.floor(((totals.was - totals.now) / totals.was) * 100);
    }

    function paintCard(tierKey) {
      var totals = packTotals(tierKey);
      var nowEl = root.querySelector('[data-gbac-now="' + tierKey + '"]');
      var wasEl = root.querySelector('[data-gbac-was="' + tierKey + '"]');
      var pillEl = root.querySelector('[data-gbac-pill="' + tierKey + '"]');
      var count = tierKey === '1' ? 1 : rowsState[tierKey].length;
      /* Packs: per-chain price in the header, the total as a subtotal under the rows (Deven, 2026-10-30). */
      if (tierKey !== '1' && count > 0) {
        if (nowEl) nowEl.innerHTML = formatMoney(Math.round(totals.now / count), moneyFormat) + ' <span class="gbac-pb__each">each</span>';
        if (wasEl) wasEl.hidden = true;
        var subNowEl = root.querySelector('[data-gbac-sub-now="' + tierKey + '"]');
        var subWasEl = root.querySelector('[data-gbac-sub-was="' + tierKey + '"]');
        if (subNowEl) subNowEl.textContent = formatMoney(totals.now, moneyFormat);
        if (subWasEl) {
          if (totals.was > totals.now) { subWasEl.textContent = formatMoney(totals.was, moneyFormat); subWasEl.hidden = false; }
          else { subWasEl.hidden = true; }
        }
      } else {
        if (nowEl) nowEl.textContent = formatMoney(totals.now, moneyFormat);
        if (wasEl) {
          if (totals.was > totals.now) { wasEl.textContent = formatMoney(totals.was, moneyFormat); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      }
      if (pillEl) {
        var pct = pctSaved(totals);
        if (pct > 0) { pillEl.textContent = 'Save ' + pct + '%'; pillEl.hidden = false; }
        else { pillEl.hidden = true; }
      }
    }

    /* Toggle a sibling select's option availability without rebuilding it,
       since the two selects in a row are mutually dependent: changing
       Length can sold-out an option in the Finish select and vice versa. */
    function refreshOptions(select, kind, row) {
      var opts = kind === 'finish' ? FINISHES : LENGTHS;
      var current_val = kind === 'finish' ? row.finish : row.length;
      Array.prototype.forEach.call(select.options, function (opt, i) {
        var val = opts[i];
        var p = kind === 'finish' ? findProduct(val, row.length) : findProduct(row.finish, val);
        var soldOut = !p || !p.available;
        var isCurrent = val === current_val;
        opt.textContent = val + (soldOut ? ' (sold out)' : '');
        /* Never disable the option that is this row's OWN current value --
           a row can legitimately sit on a sold-out combo and the select must
           still show it as selected. Disabling it would blank the select
           instead of communicating "sold out". */
        opt.disabled = soldOut && !isCurrent;
        opt.selected = isCurrent;
      });
    }

    function paintRow(rowEl, row, tierKey) {
      var p = products[row.handle];
      var swatchEl = rowEl.querySelector('[data-gbac-swatch]');
      if (swatchEl) swatchEl.setAttribute('data-finish', String(row.finish || '').toLowerCase());
      var wasEl = rowEl.querySelector('[data-gbac-row-was]');
      var nowEl = rowEl.querySelector('[data-gbac-row-now]');
      var packCents = rowPackCents(p, tierKey);
      var compareCents = rowCompareCents(p);
      if (nowEl) nowEl.textContent = formatMoney(packCents, moneyFormat);
      if (wasEl) {
        if (compareCents > packCents) { wasEl.textContent = formatMoney(compareCents, moneyFormat); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      var finishSel = rowEl.querySelector('[data-field="finish"]');
      var lengthSel = rowEl.querySelector('[data-field="length"]');
      if (finishSel) refreshOptions(finishSel, 'finish', row);
      if (lengthSel) refreshOptions(lengthSel, 'length', row);
      var unavailable = !p.available;
      rowEl.classList.toggle('gbac-pb__row--unavailable', unavailable);
      var noteEl = rowEl.querySelector('[data-gbac-row-note]');
      if (noteEl) noteEl.hidden = !unavailable;
    }

    function buildSelect(kind) {
      var select = document.createElement('select');
      select.className = 'gbac-pb__select';
      select.setAttribute('data-field', kind);
      select.setAttribute('aria-label', kind === 'finish' ? 'Finish' : 'Length');
      var opts = kind === 'finish' ? FINISHES : LENGTHS;
      opts.forEach(function (val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        select.appendChild(opt);
      });
      return select;
    }

    function renderRows(tierKey) {
      var list = root.querySelector('[data-gbac-row-list="' + tierKey + '"]');
      if (!list) return;
      list.innerHTML = '';
      rowsState[tierKey].forEach(function (row, idx) {
        var rowEl = document.createElement('div');
        rowEl.className = 'gbac-pb__row';
        rowEl.dataset.rowIdx = String(idx);
        rowEl.dataset.tier = tierKey;

        /* Finish swatch, the same convention and size as the buy box's
           sibling swatches, repainted by paintRow() when Finish changes. */
        var swatch = document.createElement('span');
        swatch.className = 'gbac-pb__swatch';
        swatch.setAttribute('data-gbac-swatch', '');
        swatch.setAttribute('aria-hidden', 'true');

        var finishField = document.createElement('span');
        finishField.className = 'gbac-pb__field';
        finishField.appendChild(buildSelect('finish'));

        var lengthField = document.createElement('span');
        lengthField.className = 'gbac-pb__field';
        lengthField.appendChild(buildSelect('length'));

        /* Struck compare-at above the pack price (Loom 2026-09-03). */
        var priceEl = document.createElement('span');
        priceEl.className = 'gbac-pb__row-price';
        var wasEl = document.createElement('s');
        wasEl.className = 'gbac-pb__row-was';
        wasEl.setAttribute('data-gbac-row-was', '');
        var nowEl = document.createElement('span');
        nowEl.className = 'gbac-pb__row-now';
        nowEl.setAttribute('data-gbac-row-now', '');
        priceEl.appendChild(wasEl);
        priceEl.appendChild(nowEl);

        var noteEl = document.createElement('span');
        noteEl.className = 'gbac-pb__row-note';
        noteEl.setAttribute('data-gbac-row-note', '');
        noteEl.hidden = true;
        noteEl.textContent = 'Sold out, please choose a different option';

        rowEl.appendChild(swatch);
        rowEl.appendChild(finishField);
        if (multiLength) rowEl.appendChild(lengthField);
        else rowEl.classList.add('gbac-pb__row--one-length');
        rowEl.appendChild(priceEl);
        rowEl.appendChild(noteEl);
        list.appendChild(rowEl);

        paintRow(rowEl, row, tierKey);
      });
    }

    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
    function hideError() { if (errEl) errEl.hidden = true; }

    function updateAddState() {
      if (tier === '1') { hideError(); return; }
      var totals = packTotals(tier);
      if (addPriceEl) addPriceEl.textContent = formatMoney(totals.now, moneyFormat);
      /* Struck compare-at on the button too, as the native button shows it (Kim, 2026-09-04). */
      if (addWasEl) {
        if (totals.was > totals.now) { addWasEl.textContent = formatMoney(totals.was, moneyFormat); addWasEl.hidden = false; }
        else { addWasEl.hidden = true; }
      }
      if (addLabelEl) addLabelEl.textContent = ctaLabel;
      if (!addBtn) return;
      if (!totals.allAvailable) {
        addBtn.disabled = true;
        showError('One or more chains in this pack are sold out. Please choose a different ' + (multiLength ? 'finish or length' : 'finish') + ' for the highlighted row.');
      } else {
        addBtn.disabled = false;
        hideError();
      }
    }

    function recalcAll() {
      paintCard('1');
      paintCard('2');
      paintCard('5');
      renderRows('2');
      renderRows('5');
      updateAddState();
    }

    function selectTier(newTier) {
      tier = newTier;
      root.querySelectorAll('[data-gbac-rows]').forEach(function (el) {
        el.hidden = el.getAttribute('data-gbac-rows') !== tier;
      });
      root.querySelectorAll('.gbac-pb__card').forEach(function (el) {
        el.classList.toggle('gbac-pb__card--active', el.dataset.tier === tier);
      });
      setPackMode(tier !== '1');
      updateAddState();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) selectTier(r.value); });
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-field]')) return;
      var rowEl = t.closest('.gbac-pb__row');
      if (!rowEl) return;
      var tierKey = rowEl.dataset.tier;
      var idx = parseInt(rowEl.dataset.rowIdx, 10);
      var row = rowsState[tierKey][idx];
      var field = t.getAttribute('data-field');
      var newFinish = field === 'finish' ? t.value : row.finish;
      var newLength = field === 'length' ? t.value : row.length;
      var p = findProduct(newFinish, newLength);
      if (p) {
        row.finish = newFinish;
        row.length = newLength;
        row.handle = p.handle;
      }
      paintCard(tierKey);
      paintRow(rowEl, row, tierKey);
      updateAddState();
    });

    function setBusy(b) {
      if (!addBtn) return;
      addBtn.classList.toggle('is-busy', b);
      addBtn.setAttribute('aria-busy', b ? 'true' : 'false');
      addBtn.disabled = b || !packTotals(tier).allAvailable;
    }

    function addPackToCart() {
      if (tier === '1') return; /* Single Chain goes through the theme's own form */
      hideError();
      var items = rowsState[tier].map(function (r) { return { id: products[r.handle].variantId, quantity: 1 }; });
      setBusy(true);
      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && r.data.description) || 'add failed');
          /* The shim's tell is 200 with an empty (or short) items array. If
             the whitelist ever stops matching, say so instead of claiming a
             success we did not get. */
          if (!r.data || !Array.isArray(r.data.items) || r.data.items.length !== items.length) {
            throw new Error('partial add');
          }
          if (typeof window.openCart === 'function') {
            try { window.openCart(); } catch (e) {}
          }
          addBtn.classList.add('is-added');
          setTimeout(function () { addBtn.classList.remove('is-added'); }, 2000);
        })
        .catch(function () {
          showError('We could not add everything to your cart. Please try again.');
        })
        .then(function () { setBusy(false); });
    }

    if (addBtn) addBtn.addEventListener('click', addPackToCart);

    selectTier('2');
    recalcAll();
  }

  function boot() { document.querySelectorAll('gbac-pack-builder').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('variant:change', boot);
})();
